const routerOptions = {
    checkout: {
        path: '/checkout/:stepName*',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "checkout" */ '../components/checkout/Checkout'),
        meta: {
            metaInfoProvider: true,
            resource: '*/order-process',
            priority: 1,
        },
    },
};

export default routerOptions;
